// 花神主题

import { useMemo } from 'react';
import { theme } from 'antd';

const useBlossomTheme = () => {
  return useMemo(
    () => ({
      theme: {
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: '#ED4192',
          borderRadius: 16,
        },
        components: {
          Layout: {
            bodyBg: '#fff4fa',
            footerBg: '#fff4fa',
            headerBg: '#ffffff',
            headerColor: '#3f2330',
            siderBg: '#fff7fb',
            triggerBg: '#ffe4f0',
            triggerColor: '#ED4192',
          },
          Menu: {
            activeBarBorderWidth: 0,
            itemBg: 'transparent',
            subMenuItemBg: 'transparent',
          },
          Progress: {
            circleTextColor: '#3f2330',
            defaultColor: '#ED4192',
            remainingColor: 'rgba(237, 65, 146, 0.14)',
          },
        },
      },
    }),
    [],
  );
};

export default useBlossomTheme;
